import React from "react";
import css from "./heading.module.css";

const Heading = ({ icon, headingTitle, dark = false }) => {
  return (
    <div className={`${css.wrapper} ${dark ? css.dark : ""}`}>
      <div className={css.header}>
        <div className={css.title}>
          <span className={css.icon}>{icon}</span>
          <span>{headingTitle}</span>
        </div>
        <span className={css.line} aria-hidden="true" />
      </div>
    </div>
  );
};

export default Heading;
